import { useMemo } from 'react';
import { castToUnion } from '@lingoda/utils';

const useCastToUnionMemo = <T>(value: unknown, options: T[]): T | undefined =>
    useMemo(() => castToUnion(value, options), [value, options]);

export default useCastToUnionMemo;
